import { ProtectedAreasOsm } from '@/api/rest/resources/types/protectedAreas';

export const LANDLER_CAT_TO_OSM_CATEGORY: Record<number, ProtectedAreasOsm> = {
  1: ProtectedAreasOsm.strictly_protected_area,
  2: ProtectedAreasOsm.national_park_natural_monument,
  3: ProtectedAreasOsm.habitat_and_species_management_area,
  4: ProtectedAreasOsm.protected_landscape_and_sustainable_use_area,
  5: ProtectedAreasOsm.water_protection_area,
  6: ProtectedAreasOsm.cultural_and_indigenous_area,
  7: ProtectedAreasOsm.internationally_and_nationally_recognized_area,
  8: ProtectedAreasOsm.unclassified,
} as const;

export type LayerFeature = {
  type: string;
  id: string;
  properties: {
    [key: string]: string | number | null;
  };
};

/**
 * GET /mapserver.landler.io/geoserver/landscape/wms/
 */
export const GET_GEOSERVER_LAYER_FEATURES = 'https://mapserver.landler.io/geoserver/landscape/wms';
export type GetGeoserverLayerFeaturesPathVariables = undefined;
export type GetGeoserverLayerFeaturesQueryParams = {
  SERVICE: string;
  VERSION: string;
  REQUEST: string;
  FORMAT: string;
  TRANSPARENT: string;
  QUERY_LAYERS: string;
  LAYERS: string;
  INFO_FORMAT: string;
  X: number;
  Y: number;
  SRS: string;
  WIDTH: number;
  HEIGHT: number;
  BBOX: string;
};
export type GetGeoserverLayerFeaturesSuccessDto = {
  type: string;
  features: LayerFeature[];
};
export type GetGeoserverLayerFeaturesErrorDto = Error;
